import { verifySendPV } from '@/constants/buryingpoint'

const originalPushState = window?.history?.pushState
if (originalPushState) {
  history.pushState = function(...arg) {
    statistics()
    verifySendPV()
    return originalPushState.apply(history, arguments)
  }
}
const originalReplaceState = history?.replaceState
if (originalReplaceState) {
  history.replaceState = function() {
    statistics()
    // note:replace不能发送埋点
    // verifySendPV()
    return originalReplaceState.apply(history, arguments)
  }
}

const originalBack = history?.back
if (originalBack) {
  history.back = function(state, title, url) {
    statistics()
    verifySendPV()
    return originalBack.apply(history, arguments)
  }
}

const originalForward = history?.forward
if (originalForward) {
  history.forward = function(state, title, url) {
    statistics()
    verifySendPV()
    return originalForward.apply(history, arguments)
  }
}

const originalGo = history?.go
if (originalGo) {
  history.go = function(state, title, url) {
    statistics()
    verifySendPV()
    return originalGo.apply(history, arguments)
  }
}

const statistics = () => {
  const page = window.location.pathname.split('/')[1]
  const host = window.location.host
  if (page) {
    _hmt.push(['_trackEvent', `${host}/${page}/ALL`, 'pv'])
  } else {
    _hmt.push(['_trackEvent', `${host}/NO/ALL`, 'pv'])
  }
}
window.addEventListener?.('popstate', function(PopStateEvent) {
  verifySendPV()
  statistics()
})

// IE兼容处理
window.attachEvent?.('onpopstate', function() {
  statistics()
})

statistics()
export default statistics
